import { Text, contentBlurStyles } from '@soteria/design-system-ve';
import { useState } from 'react';

import * as imageStyles from './ContentCardImage.css';

interface ImageThumbnailProps {
  imageUrl: string;
  altText: string;
  isSafe: boolean;
  isContentBlurred: boolean;
}

/**
 * Displays an image thumbnail with blur support for unsafe content.
 * Shows a fallback message on load error.
 */
export function ImageThumbnail({ imageUrl, altText, isSafe, isContentBlurred }: ImageThumbnailProps) {
  const [imageError, setImageError] = useState(false);

  if (imageError) {
    return (
      <div aria-label={altText} className={imageStyles.thumbnailContainer} role="img">
        <Text className={imageStyles.thumbnailErrorText}>Image unavailable</Text>
      </div>
    );
  }

  const applyBlur = !isSafe && isContentBlurred;

  return (
    <div className={imageStyles.thumbnailContainer}>
      <img
        alt={altText}
        className={`${imageStyles.thumbnailImage} ${applyBlur ? contentBlurStyles.blurredThumbnail : ''}`}
        src={imageUrl}
        onError={() => setImageError(true)}
      />
    </div>
  );
}
